import { ApiDOMError } from '@swagger-api/apidom-error';
class JsonSchemaUriError extends ApiDOMError {}
export default JsonSchemaUriError;